import api from '@/services/api'

export const actions = {
    getPageData(context) {
        return new Promise((resolve) => {
            api('/home-articles')
            .then((data)=> {
                resolve(context.commit('homepageData', data));
            })
            .catch(() => {
                return
            });
        });
    },
}